import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from './AdminAuthContext';

export default function PrivateRoute({ children }) {
  const { isAuthed } = useAdminAuth();
  return isAuthed ? children : <Navigate to="/login" replace />;
}
